

export const GET_POINT = 'GET_POINT';
export const GET_POINT_SUCCESS = 'GET_POINT_SUCCESS';
export const GET_COUPON = 'GET_COUPON';
export const GET_COUPON_SUCCESS = 'GET_COUPON_SUCCESS';
export const USE_COUPON = 'USE_COUPON';
export const RESET_COUPON = 'RESET_COUPON';
export const EXCHANGE_POINT_TO_COUPON_REQUEST = 'EXCHANGE_POINT_TO_COUPON_REQUEST';
export const EXCHANGE_POINT_TO_COUPON_SUCCESS = 'EXCHANGE_POINT_TO_COUPON_SUCCESS';
export const EXCHANGE_POINT_TO_COUPON_FAILED = 'EXCHANGE_POINT_TO_COUPON_FAILED';